<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>PRO-VICE CHANCELLOR & DEAN ACADEMIC MESSAGE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Pro-Vice Chancellor & Dean Academic Message</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02 border py-6">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9">
                <div class="col-lg-12 order-2 order-lg-1">
                    <img src="assets/img/chancellor/5.jpg"/>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">Dean Academic Message</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">Pro-Vice Chancellor & Dean Academic Message</h2>
                 <p class="px-2" align="justify">It’s a great pleasure for me to be a part of <b>Arni University</b> and I take this opportunity of
                    welcoming
                    students coming from all parts of the country and abroad, joining various academic programs of Arni
                    University.</p>

                 <p class="px-2" align="justify">Education is an ongoing purposeful social process in society, through which our inherent powers are
                    developed, our knowledge and skills are increased and our behavior is changed and accordingly, we
                    made cultured, civilized, and capable citizens. The Arni University is working to transform young
                    talent, through cutting-edge education in science, medical, technology, Agriculture, education,
                    arts, management, and many more, integrated with values for their holistic development to serve
                    mankind with empathy and love.</p>

                 <p class="px-2" align="justify">We are committed to providing the best learning platform for the students to participate in seminars,
                    business plan competitions, branding exercises, career advancement workshops, sports, cultural
                    activities, village development activities, social works etc. and enable students to learn and use
                    their learning for solving issues in various areas specific.</p>
                <div class="section-heading text-start mb-0 mt-3">
                    <span class="sub-title text-secondary">Prof. (Dr.) Manish Kumar Srivastava</span>
                </div>
            </div>
            <div class="col-lg-12 col-xl-12 mt-2">
                 <p class="px-2" align="justify">The National Cadet Corps (NCC) wing of the University together with the cultural committee organizes
                    programs and activities that connect a sense of harmony, community connection, ethical values, and
                    citizenship among the students. All activities of the University are aimed towards facilitating and
                    empowering future generations by supporting collaborative initiatives, promoting multidisciplinary
                    research, and strengthening their technical competence. The university also offers various
                    <b>international Training and Tours</b> as a reward for Academic Excellence with our International
                    tie-ups
                    to give international exposure to our students. For the holistic development of our students, we
                    have <b>prepared skill and job- oriented different curricula </b> with the help of Industry,
                    academia, and
                    social and cultural reformers.</p>

                 <p class="px-2" align="justify">We are continuously working towards carving a position in higher education by offering
                    multidisciplinary learning opportunities and inculcating the students with core competencies of the
                    21st century.</p>

                 <p class="px-2" align="justify">I wish you great success in all your future endeavors, and assure you, that we will help you to
                    pursue your objectives and help to create a path to get success in your goals.</p>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>
